import { gql } from '@apollo/client';

export const deleteCampaign = gql`
    mutation deleteCampaign($deleteCampaignId: ID!) {
        deleteCampaign(id: $deleteCampaignId) {
            id
        }
    }
`;
